<template>
    <div class="w3-container">
      <!-- 登录表单卡片 -->
      <div class="w3-margin-top">
        <form @submit.prevent="newWithdraw" class="w3-container w3-padding-16">
          <div class="w3-section">
          <label class="w3-text-blue"><b>可提USDT数量</b></label>
          <input
            type="text"
            class="w3-input w3-border"
            v-model="userCoin"
            v-input-filter="'number'"
            placeholder="可提USDT数量"
            :disabled="true" 
            required
          >
        </div>

          <div class="w3-section">
          <label class="w3-text-blue"><b>Tron (TRC20)地址</b></label>
          <input
            type="text"
            class="w3-input w3-border"
            v-model="tronAddr"
            v-input-filter="'number'"
            placeholder="请输入Tron (TRC20)地址"
            @input="tronAddr = tronAddr.replace(/[^0-9a-zA-Z]/g, '')"
            required
          >
          <div>提醒：请提供波场Tron(TRC20)地址，其它网络会导致资金丢失</div>
        </div>


          <div class="w3-section">
            <label class="w3-text-blue"><b>要提数量, 5USDT起提</b></label>
            <input
              type="text"
              class="w3-input w3-border"
              v-model="withdrawCoin"
              @input="onInput"
              placeholder="请输入要提的USDT数量"
              required
            >
          </div>

          <!-- 提交按钮 -->
          <div style="margin-top: 50px;">
            <button type="submit" :disabled="!isValidWithdraw" class="w3-button w3-blue w3-block">
              立即提交
            </button>
          </div>
  
          <!-- 提示消息 -->
          <div v-if="message" :class="messageClass">
            <p>{{ message }}</p>
          </div>

        </form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        userCoin: '',
        tronAddr: '',
        withdrawCoin: '',
        message: '',
        userName: '',
        userPass: '',
        isSuccess: false
      };
    },
    created() {
      const query = this.$route.query;
      if(query.u && query.p) {
        sessionStorage.setItem('userName', query.u);
        sessionStorage.setItem('userPass', query.p);
      }
      this.userName = sessionStorage.getItem('userName');
      this.userPass = sessionStorage.getItem('userPass');
      if(this.userName && this.userPass) {
        this.fetchUserCoin();
        this.fetchData();
      } else {
        this.$router.push('/login');
      }
  
    },
    computed: {
      messageClass() {
        return this.isSuccess 
          ? 'w3-panel w3-green w3-round' 
          : 'w3-panel w3-red w3-round';
      },
      isValidWithdraw() {
        const amount = parseFloat(this.withdrawCoin);
        return !isNaN(amount) && amount >= 5 && amount <= parseFloat(this.userCoin);
      }
    },
    methods: {
      onInput(e) { 
        let v = e.target.value;
         // 只允许数字和小数点
         v = v.replace(/[^0-9.]/g, ''); 
         // 只允许一个小数点
          v = v.replace(/\.{2,}/g, '.'); 
          v = v.replace(/^(\d+)\.(.*)\./, '$1.$2');
           // 限制为两位小数 
          v = v.replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2');
           
          this.withdrawCoin = v;

         },
        async fetchData() {
          this.loading = true;
          this.error = '';
          try {

            const response = await fetch(`${this.$apiUrl}/getLastWithdrawAddr`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              username: this.userName,
              t: this.userPass
            })
          });

          const data = await response.json();
          const respObj = data.result;
          this.tronAddr = respObj[0].TronAddr;

          } catch (err) {
              this.error = '获取数据失败，请稍后重试。';
          } finally {
              this.loading = false;
          }
        },
        async fetchUserCoin() {
          this.loading = true;
          this.error = '';
          try {

              const response = await fetch(`${this.$apiUrl}/getUserCoin`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  username: this.userName,
                  t: this.userPass
                })
              });

              const data = await response.json();            
              const respObj = data.result;
              this.userCoin = respObj[0].Coin;

          } catch (err) {
              this.error = '获取数据失败，请稍后重试。';
          } finally {
              this.loading = false;
          }
        },
        async newWithdraw() {
        try {

          // 检查是否为空
          if (!this.withdrawCoin) {
            this.message = '请输入USDT地址与数量';
            this.isSuccess = false;
            return;
          }
          // 检查是否为空
          if (!this.tronAddr || !this.withdrawCoin) {
            this.message = '请输入USDT地址与数量';
            this.isSuccess = false;
            return;
          }

          const response = await fetch(`${this.$apiUrl}/newWithdraw`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              username: this.userName,
              password: this.userPass,
              tronAddr: this.tronAddr,
              coin: this.withdrawCoin
            })
          });

          const data = await response.json();

          this.isSuccess = data.code === 200;
          this.message = data.msg;

          if(this.isSuccess) {
            this.message = '提交成功！';
            this.$router.push('/withdrawTX');
          }

          //清空表单
          this.withdrawCoin = '';

        } catch (error) {
          this.isSuccess = false;
          this.message = '网络错误，请检查连接';
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* 可选：自定义补充样式 */
  .w3-card {
    margin-top: 30px;
  }
  
  .w3-input {
    margin-top: 5px;
  }
  </style>